<div class="full-screen-container">
    <mat-icon (click)="clearClick.emit()">clear</mat-icon>
    <ng-content></ng-content>
</div>
